export const visit = (vm, at) => {
at({ "fr": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "fonctionnalit\xE9 disponible", "featureUnavailable": "fonctionnalit\xE9 indisponible" } } } } });
};